import React from "react";

const PokerResult = ({ resultData }) => {
  const cardImg = (value) =>
    value && value !== "1"
      ? `/assets/galaxy/img/cards3/${value}.svg`
      : "/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg";

  return (
    <div id="ResultsData" className="tabcontent" style={{ display: "block" }}>
      <div className="left-content">
        {resultData &&
          resultData.length > 0 &&
          resultData.map((dataObj, index) => {
            const win1 = dataObj.result == 1 ? "WINNER" : "LOSER";
            const win2 = dataObj.result == 2 ? "WINNER" : "LOSER";
            const tdCls1 = win1 === "WINNER" ? "TdResultsWin" : "";
            const tdCls2 = win2 === "WINNER" ? "TdResultsWin" : "";
            const communityCards = ["cc1", "cc2", "cc3", "cc4", "cc5"];

            return (
              <div
                key={index}
                className="card"
                style={{
                  border: "1px solid rgb(204, 204, 204)",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                  marginBottom: "5px",
                  background:
                    "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                  color: "white"
                }}
              >
                <div
                  className="card-header"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "5px",
                    background: "transparent",
                    borderBottom: "solid 1px #000"
                  }}
                >
                  {dataObj.evt_od} - (<b>Round Id = </b> {dataObj.evt_id})
                </div>
                <div className="card-body">
                  <div
                    className="players-table"
                    style={{ textAlign: "center", width: "100%" }}
                  >
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-evenly",
                            background: "transparent"
                          }}
                        >
                          <td className="TdResults">
                            <div
                              className="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <div
                                className="player-name"
                                style={{ fontWeight: "bold", marginBottom: "5px" }}
                              >
                                Community Cards
                              </div>
                              <div
                                className="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px",
                                  flexWrap: "wrap"
                                }}
                              >
                                {communityCards.map((key) => (
                                  <img
                                    key={key}
                                    src={cardImg(dataObj[key])}
                                    alt=""
                                    style={{
                                      width: "40px",
                                      height: "60px",
                                      objectFit: "cover",
                                      borderRadius: "5px"
                                    }}
                                  />
                                ))}
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-evenly",
                            background: "transparent"
                          }}
                        >
                          <td className={`TdResults ${tdCls1}`}>
                            <div
                              className="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <div
                                className="player-name"
                                style={{ fontWeight: "bold", marginBottom: "5px" }}
                              >
                                Player A
                              </div>
                              <div
                                className="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px"
                                }}
                              >
                                <img
                                  src={cardImg(dataObj.ac1)}
                                  alt=""
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                                <img
                                  src={cardImg(dataObj.ac2)}
                                  alt=""
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                              </div>
                              <div
                                className={win1 === "WINNER" ? "bgwinner" : "bgLoser"}
                                style={{
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  width: "100%"
                                }}
                              >
                                {win1}
                              </div>
                            </div>
                          </td>
                          <td className={`TdResults ${tdCls2}`}>
                            <div
                              className="player-cards"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <div
                                className="player-name"
                                style={{ fontWeight: "bold", marginBottom: "5px" }}
                              >
                                Player B
                              </div>
                              <div
                                className="card-images"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "3px"
                                }}
                              >
                                <img
                                  src={cardImg(dataObj.bc1)}
                                  alt=""
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                                <img
                                  src={cardImg(dataObj.bc2)}
                                  alt=""
                                  style={{
                                    width: "40px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "5px"
                                  }}
                                />
                              </div>
                              <div
                                className={win2 === "WINNER" ? "bgwinner" : "bgLoser"}
                                style={{
                                  marginTop: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  width: "100%"
                                }}
                              >
                                {win2}
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default PokerResult;
